angular.module("app").controller("colorResearchController", [
  "$scope",
  function (
    scope
  ) {

  },
]);
